import React, { useEffect, useState, useRef } from 'react';

import { useStylesMUI } from '../../../styles/home/style';
import { TemplateABM } from '../../atomic/templates/TemplateABM';
import { ValidatorInputField } from '../../atomic/atoms/Inputs';
import { required } from '../../../helpers/validations/validators';
import { useTotem } from '../../../hooks/useCases/useTotem';
import { SelectValidatorGeneric } from '../../atomic/atoms/Select';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import TableGeneric from '../../compartidos/abms/TableGeneric';

const initModal = {
  open: false,
  value: '',
  title: '',
};

export const TotemSubOpcionesABM = () => {
  const classes = useStylesMUI();
  const totem = useTotem();
  const componentRef = useRef();

  const [modalRecepciones, setModalRecepciones] = useState(initModal);

  useEffect(() => {
    totem.get.opciones();
    totem.get.subOpciones();
    totem.get.recepciones();
  }, []);

  return (
    <div className={classes.root}>
      <TemplateABM
        sizeTableCells={['16', '16%', '16%', '16%', '20%', '16%']}
        titles={{
          abm: 'Sub Opciones Totem',
          insert: 'Agregar Sub Opción',
          update: 'Modificar Sub Opción',
          delete: 'Eliminar Sub Opción',
        }}
        data={(data) => ({
          id: data?.id || '',
          descripcion: data?.descripcion || '',
          idOpcion: data?.opcion?.id || '',
          idRecepcion: data?.recepcion?.id || '',
          mensaje: data?.mensaje || '',
        })}
        formStructure={({ formValues, handleInputChange }) => [
          {
            Component: ValidatorInputField,
            variant: 'outlined',
            label: 'Descripcion',
            name: 'descripcion',
            value: formValues.descripcion,
            onChange: handleInputChange,
            validations: [required],
            grid: { xs: 12, md: 4 },
          },
          {
            Component: SelectValidatorGeneric,
            label: 'Opciones',
            name: 'idOpcion',
            value: formValues.idOpcion,
            onChange: handleInputChange,
            validations: [required],
            grid: { xs: 12, md: 4 },
            menuItems: totem.data.opciones.map((item) => ({
              value: item.id,
              label: item.descripcion,
            })),
          },
          {
            Component: SelectValidatorGeneric,
            label: 'Recepciones',
            name: 'idRecepcion',
            value: formValues.idRecepcion,
            onChange: handleInputChange,
            validations: [required],
            grid: { xs: 12, md: 4 },
            menuItems: totem.data.recepciones.map((item) => ({
              value: item.id,
              label: item.descripcion,
            })),
          },
          {
            Component: ValidatorInputField,
            variant: 'outlined',
            label: 'Mensaje Totem',
            name: 'mensaje',
            multiline: true,
            rows: 4,
            value: formValues.mensaje,
            onChange: handleInputChange,
            validations: [required],
            grid: { xs: 12 },
          },
        ]}
        dataTable={{
          list: totem.data.subOpciones,
          columns: [
            {
              label: 'Descripción Sub Opción',
              id: 'descripcion',
            },
            {
              label: 'Descripción Opción',
              id: 'opcion.descripcion',
            },
            {
              label: 'Recepcion',
              id: 'recepcion.descripcion',
            },
          ],
        }}
        submit={(formValues, handleClose) => {
          const opcion = {
            id: totem.data.opciones.find(
              (item) => item.id === formValues.idOpcion,
            ).id,
            descripcion: totem.data.opciones.find(
              (item) => item.id === formValues.idOpcion,
            ).descripcion,
          };
          const recepcion = {
            id: totem.data.recepciones.find(
              (item) => item.id === formValues.idRecepcion,
            ).id,
            descripcion: totem.data.recepciones.find(
              (item) => item.id === formValues.idRecepcion,
            ).descripcion,
          };
          if (!!formValues.id)
            totem.update.subOpcion(formValues, {
              ...formValues,
              opcion,
              recepcion,
            });
          else
            totem.insert.subOpcion(formValues, {
              ...formValues,
              opcion,
              recepcion,
            });
          handleClose();
        }}
        deleteButton={(id, handleClose) => {
          totem.remove.subOpcion(id);
          handleClose();
        }}
      />

      {modalRecepciones.open && (
        <GenericModal
          open={modalRecepciones.open}
          closeModal={() => {
            setModalRecepciones(initModal);
          }}
          title={modalRecepciones.title}
          gridStyle={{ textAlign: 'center', padding: '1em' }}
          maxWidth="sm"
        >
          <div style={{ border: '1px solid #ddd' }}>
            <TableGeneric
              ref={componentRef}
              data={modalRecepciones.value}
              withoutPagination
              align="center"
              colTitleStyle={{ fontSize: '1.2em' }}
              columns={[
                {
                  id: 'descripcion',
                  label: 'Descripción',
                },
              ]}
            />
          </div>
        </GenericModal>
      )}
    </div>
  );
};
